import { provideZoneChangeDetection } from "@angular/core";
/// <reference types="@angular/localize" />

import {createInterceptorCondition, 
  CustomBearerTokenCondition, 
  CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG
} from 'keycloak-angular';

import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {environment} from "./environments/environment";



const initializeApp = async () => {

  // disable logging if running in production
  if (environment.production) {
    if (window) {
      window.console.log = function(){};
    }
  }

  // get all backend urls to configure the interceptor
  const backendURLS = [environment.well_known_url];
  const wellKnown = await fetch(environment.well_known_url).then((res) => res?.json());
  const customers = (wellKnown as { customers?: any[] }).customers || [];
  backendURLS.push(...customers.flatMap((customer: { links: { href: string }[] }) => 
    customer.links.map(link => link.href)));
  console.log('got backend urls from the well-known document, using them to configure the interceptor');

  const urlInterceptCondition = createInterceptorCondition<CustomBearerTokenCondition>({
    shouldAddToken: async (req: any, _: any, keycloak: any): Promise<boolean> => {
      return backendURLS.some(url => req.url.startsWith(url));
    },
    bearerPrefix: 'Bearer'
  });

  
  await bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(),
    ...appConfig.providers,
    {
      provide: CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlInterceptCondition]
    }    
  ]});
};



initializeApp().catch((error) => console.error(`Failed to initialize the application. ${error.message || error}`));